import PropTypes from "prop-types";
import { Stack, Tooltip, Typography } from "@mui/material";
import { Lock } from "lucide-react";

import { readOnlyCardMessage } from "@/utils/clientAccess";

export function ReadOnlyCardTooltip({ active, children }) {
  if (!active) return children;
  return (
    <Tooltip
      arrow
      placement="top"
      enterDelay={250}
      title={
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Lock size={14} style={{ flexShrink: 0 }} />
          <Typography sx={{ fontSize: "0.75rem" }}>{readOnlyCardMessage}</Typography>
        </Stack>
      }
    >
      {children}
    </Tooltip>
  );
}

ReadOnlyCardTooltip.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.element.isRequired,
};
